import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import JsonViewer from "vue-json-viewer";

import router from "./router";
import store from "./store";
import api from "./utils/api";
// import { tracking } from './utils/tracking';

import App from "./App.vue";

// const isDev = process.env.NODE_ENV === 'development';

Vue.config.productionTip = false;
Vue.prototype.$api = api;
// Vue.prototype.$notify = (options) => {
//   this.$notify(options);
// };
// Vue.prototype.$trackEvent = isDev ? console.log : tracking.trackEvent;

// configure language
locale.use(lang);
Vue.use(ElementUI);
Vue.use(JsonViewer);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
